var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.25,
    height: 20,
    viewBox: "0 0 19.25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-save-1360328",
    transform: "translate(-134.4 -56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17261",
    "data-name": "Path 17261",
    d: "M153.65,61.35,148.83,56H134.4V76h19.25ZM138.775,57h8v3.875h-8ZM152.65,75H135.4V57h2.375v4.875h10V57h.61l4.265,4.733Z",
    fill: "#3b4452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17262",
    "data-name": "Path 17262",
    d: "M265.366,242.37a4.133,4.133,0,1,0,2.916,1.21,4.128,4.128,0,0,0-2.916-1.21Zm0,7.219a3.089,3.089,0,1,1,2.184-.908,3.086,3.086,0,0,1-2.184.908Z",
    transform: "translate(-121.341 -178.278)",
    fill: "#3b4452"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save__icon.da2d11a2dab250565dc11f3e50b653f6.svg";
export { ForwardRef as ReactComponent };